module.exports = __webpack_public_path__ + "img/sites.869a52c4.svg";